import React, { useEffect } from 'react';
import './App.css';
import AppRoutes from './routes';
import { BASE_URL, envConfig } from "./config";
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from './store';
import { setUser } from './store/slices/users.slice';

function App() {
  const dispatch = useDispatch();
  const userId = useSelector((state: RootState) => state.user._id);

  useEffect(() => {
    fetch(BASE_URL + "health", {
      headers: { "api-key": envConfig.API_KEY },
    });

    // Hydrate Redux from an active BetterAuth cookie session.
    // This covers the OAuth redirect case where the cookie is set but Redux is empty.
    if (!userId) {
      fetch(BASE_URL + "auth/me", {
        credentials: "include",
        headers: { "api-key": envConfig.API_KEY },
      })
        .then((res) => (res.ok ? res.json() : null))
        .then((userData) => {
          if (userData?._id) dispatch(setUser(userData));
        })
        .catch(() => {});
    }
  }, []);

  return <AppRoutes />;
}

export default App;
